import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import colors from '../../constants/colors';
import { FaCalendarAlt, FaInfoCircle } from 'react-icons/fa';

const ServiceCard = ({ service }) => {
    return (
        <Card className="h-100 service-card">
            <Card.Img 
                variant="top" 
                src={service.image} 
                alt={`Imagem do serviço ${service.name}`}
                loading="lazy"
                style={{ height: '200px', objectFit: 'cover' }}
            />
            <Card.Body className="d-flex flex-column">
                <Card.Title style={{ color: colors.dark }}>{service.name}</Card.Title>
                <Card.Text className="small mb-2" style={{ color: colors.textGray }}>
                    {service.short_description?.length > 80 
                        ? service.short_description.substring(0, 80) + '...'
                        : service.short_description}
                </Card.Text>
                <div className="mt-auto">
                    <div className="d-flex gap-2">
                        <Button
                            as={Link}
                            to={`/servicos/${service.id}`}
                            className="flex-grow-1"
                            style={{ 
                                backgroundColor: colors.primary, 
                                borderColor: colors.primary,
                                color: colors.secondary
                            }}
                        >
                            <FaInfoCircle className="me-2" />
                            Ver mais
                        </Button>
                        <Button
                            href={service.schedule_link}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ 
                                backgroundColor: colors.secondary, 
                                borderColor: colors.secondary,
                                color: colors.light
                            }}
                        >
                            <FaCalendarAlt className="me-2" />
                            Agendar
                        </Button>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
}

export default ServiceCard;